// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { postalCodeFloatingCardStyles } from "@guestsupply/App/Widgets/PostalCodeFloatingCard/PostalCodeFloatingCard";
import { color, createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import Mail from "@insite/mobius/Icons/Mail";
import Phone from "@insite/mobius/Icons/Phone";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

postalCodeFloatingCardStyles.container = {
    css: css`
        background-color: ${color("primary")};
        position: fixed;
        top: calc(50% + 50px);
        left: 0;
        padding: 0 3px;
        padding-top: 4px;
        border-radius: 0 5px 5px 0;
        cursor: pointer;
        &:hover .enter-postal-code {
            opacity: 1;
        }
        @media print {
            display: none;
        }
    `,
};

postalCodeFloatingCardStyles.postalIcon = {
    width: 30,
    height: 40,
    css: css`
        &&&& {
            color: ${getColor("common.white")};
        }
    `,
};

postalCodeFloatingCardStyles.enterPostalCode = {
    css: css`
        position: absolute;
        background-color: ${color("common.background")};
        top: 117px;
        left: -67px;
        height: 36px;
        width: 170px;
        text-align: center;
        padding: 5px 12px;
        box-shadow: 0 0 5px 0 ${color("common.black", 0.25)};
        transition: all 200ms ease-in-out;
        transform: rotate(270deg);
        white-space: nowrap;
        opacity: 0;
    `,
};
postalCodeFloatingCardStyles.tooltipStyle = {
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
        tooltipContainer: css`
            max-width: initial;
        `,
    },
};
postalCodeFloatingCardStyles.mail = {
    ...createLinkIconStyles(Mail, {
        icon: {
            position: "left",
        },
    }),
};
postalCodeFloatingCardStyles.phone = {
    ...createLinkIconStyles(Phone, {
        icon: {
            position: "left",
        },
    }),
};
postalCodeFloatingCardStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
postalCodeFloatingCardStyles.contentContainer = {
    css: css`
        display: flex;
        gap: 8px;
    `,
};
postalCodeFloatingCardStyles.imageContainer = {
    css: css`
        width: 90px;
        height: 90px;
        ${xScreen("lte", "xs")} {
            width: 75px;
            height: 75px;
        }
    `,
};
postalCodeFloatingCardStyles.image = {
    width: "90",
    height: "90",
    css: css`
        max-width: 100%;
        max-height: 100%;
        height: auto;
        border-radius: 4px;

        img {
            opacity: 1;
        }
    `,
};
postalCodeFloatingCardStyles.infoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};
postalCodeFloatingCardStyles.salesRepTypography = {
    as: "p",
    variant: "h6",
    css: css`
        min-width: 200px;
    `,
};
